<template>
  <CFooter :fixed="false">
    <div>
      <small><a href="https://oceanbolt.com">Oceanbolt</a>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span></small>
    </div>

    <feedback class="ml-auto" />

    <div>
      <span class="ml-3 mr-3">
           <small><router-link to="/terms">Terms and Conditions</router-link></small>
      </span>
    </div>
  </CFooter>
</template>

<script>
import Feedback from "../components/Feedback";
export default {
  name: 'TheFooter',
  components: {
    Feedback,
  }
}
</script>
